import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/app/components/ui/select';
import { CURRENCIES } from '@/lib/currency';

export const CURRENCY_NO_CONVERSION_NOTE =
  'Amounts are recorded as entered — no currency conversion is applied.';

interface CurrencySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  id?: string;
  disabled?: boolean;
  className?: string;
  'aria-invalid'?: boolean;
}

export function CurrencySelect({
  value,
  onValueChange,
  id,
  disabled,
  className,
  'aria-invalid': ariaInvalid,
}: CurrencySelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger id={id} className={className} aria-invalid={ariaInvalid}>
        <SelectValue placeholder="Select currency" />
      </SelectTrigger>
      <SelectContent>
        {CURRENCIES.map(({ code, name }) => (
          <SelectItem key={code} value={code}>
            {code} — {name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
